import styled from 'styled-components';


export interface ViewProps {

}
export const View = styled.div<ViewProps>`
    position:relative
`;

export const ViewFull = styled(View)`
    width:100%;
    height:100%
`;
